const DEFAULT_SPOTIFY_EMBED_HEIGHT = 722;
const MIN_SPOTIFY_EMBED_HEIGHT = 352;
const SPOTIFY_EMBED_HEADER_HEIGHT = 200;
const SPOTIFY_TRACK_ROW_HEIGHT = 52;
const SPOTIFY_EMBED_BOTTOM_PADDING = 16;
const MAX_SPOTIFY_TRACK_COUNT = 1000;

const getSpotifyEmbedHeight = (trackCount?: number): number => {
  if (
    typeof trackCount !== "number" ||
    !Number.isInteger(trackCount) ||
    trackCount < 1 ||
    trackCount > MAX_SPOTIFY_TRACK_COUNT
  ) {
    return DEFAULT_SPOTIFY_EMBED_HEIGHT;
  }

  return Math.max(
    MIN_SPOTIFY_EMBED_HEIGHT,
    SPOTIFY_EMBED_HEADER_HEIGHT +
      trackCount * SPOTIFY_TRACK_ROW_HEIGHT +
      SPOTIFY_EMBED_BOTTOM_PADDING
  );
};

export default getSpotifyEmbedHeight;
